<script>
import Layout from "../../../layouts/main";
import ErrorAlert from "../../../../components/errorAlert.vue";
import CitySettings from "./Settings.vue";
import CitySenders from "./SenderList.vue";
import CityOtpremnice from "./OtpremnicaList.vue";
import CityShipments from "./ShipmentList.vue";

export default {
  page: { title: "City Express" },
  components: {
    Layout,
    ErrorAlert,
    CitySettings,
    CitySenders,
    CityOtpremnice,
    CityShipments,
  },
  data() {
    return {
      title: "City Express",
      activeTab: 0,
      // Tabs render their content lazily on first activation, then stay
      // mounted (kept alive via v-show) so their filters/state persist when
      // the user navigates between tabs. Tab 0 is loaded on initial mount.
      loadedTabs: [0],
    };
  },
  watch: {
    activeTab(index) {
      if (!this.loadedTabs.includes(index)) {
        this.loadedTabs.push(index);
      }
    },
  },
};
</script>

<template>
  <Layout>
    <error-alert></error-alert>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h3 class="mb-4">City Express</h3>
            <b-tabs v-model="activeTab" content-class="mt-3">
              <b-tab title="Otpremnice">
                <city-otpremnice
                  v-if="loadedTabs.includes(0)"
                  :active="activeTab === 0"
                />
              </b-tab>
              <b-tab title="Pošiljke">
                <city-shipments
                  v-if="loadedTabs.includes(1)"
                  :active="activeTab === 1"
                />
              </b-tab>
              <b-tab title="Pošiljaoci">
                <city-senders v-if="loadedTabs.includes(2)" />
              </b-tab>
              <b-tab title="Podešavanja">
                <city-settings v-if="loadedTabs.includes(3)" />
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
